import React from 'react';

import './Footer.css';

import Social from './Social';

const date = new Date();
const year = date.getFullYear();


const Footer = (props) => {
if(props.type === "light") {
    return (
      <footer className="footer--light">
        Rob Lee &copy; {year}
      </footer>
    )
  } else {
    return (
      <footer>
        <Social />
        Rob Lee &copy; {year}
      </footer>
    )
  }
}

Footer.propTypes = {  
};

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js